import { createAsyncThunk } from "@reduxjs/toolkit";
import { get_driver_profile_details } from "../../../networking/urlEndPoints";

import Axios from "../../../networking/interceptor";

export const getDriverProfile = createAsyncThunk('getDriverProfile', async (_, { rejectWithValue }) => {
    try {
        const response = await Axios.get(get_driver_profile_details)
        const data = response.data
        return data;

    } catch (error) {
        return rejectWithValue(error.response)
    }
});